<div class="modal-header">
    <h4>Calculation Preference Settings</h4>
    <a class="close-icon" href="javascript:void()" (click)="closeModal()" ngbAutofocus><i class="flaticon2-cross"></i></a>
</div>
<div class="modal-body output-lable">
    <div class="card-body" *ngIf="form">
        <div [formGroup]="form" class="calc-results-cont">
            <div class="example-section" *ngFor="let value of resultOptions">
                <mat-checkbox
                    [calc-result-check]
                    class="example-margin checkbox-wrap"
                    name="resultOptionEl"
                    [checked]="setCheckedValue(value)"
                    (change)="setFieldValue(value, $event)"
                    >{{ value }}</mat-checkbox
                >
            </div>

            <input type="hidden" [formControlName]="setFieldKey()" value="resultOptionsChecked" />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn primary-ebtn" (click)="Save()" [disabled]="saveDisabled()">Save</button>
    <button type="button" class="btn secondary-ebtn" (click)="closeModal()">Cancel</button>
</div>
